import { useEffect } from 'react';

import { trackPageView } from '../utils/analytics';

export const usePageVistTracker = (): null => {
  useEffect(() => {
    trackPageView();
  }, []);
  return null;
};
